/**
 * Rounds a number to two decimal places and replaces the decimal with a comma.
 * Example: 1234.567 → "1234,57"
 */
export function roundup(value: number | string | null | undefined): string {
  if (value == null || value === '') return '';

  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '';

  const rounded = Math.round(num * 100) / 100;
  return rounded.toString().replace('.', ',');
}
